// export const DEV = process.env.NODE_ENV === 'development';
export const ENV_PROD = false;
export const ENV_DEV = true;
export const ENV_TEST = false;
export const LOG_ENABLED = true;

export const RECAPTCHA_ENABLED = true;
export const RECAPTCHA_PUBLIC_KEY = "6Lf3dHosAAAAAARcOjM6DmfUAcv7tFXiH6AKQ-7I";

// Local Server
export const BASE_URL = 'https://qis.dae.gov.bd';
export const API_GATEWAY_URL = 'https://apigateway-qis.dae.gov.bd/';
export const CDN_URL = 'https://cdn-qis.dae.gov.bd/';
export const MEDIA_SOURCE = 'https://cdn-qis.dae.gov.bd/image/';
export const WEB_SOCKET_URL = 'https://websocket-qis.dae.gov.bd/';

export const SECURITY_UI_URL = 'https://qis.dae.gov.bd';
export const ADMIN_UI_URL = 'https://qis.dae.gov.bd';
export const CITIZEN_UI_URL = 'https://qis.dae.gov.bd';

export const AUTH_SERVER_PREFIX = "auth";
export const CDN_SERVER_PREFIX = "cdn";
export const UTIL_SERVER_PREFIX = "util";
export const QIS_SERVER_PREFIX = "qis";
export const FMIS_SERVER_PREFIX = "fmis";
export const PMIS_SERVER_PREFIX = "pmis";

export const GRANT_UI_URL = 'http://grant.most.test';
export const LICENSE_UI_URL = 'http://license.most.test';
export const LIBRARY_UI_URL = 'http://library.most.test';
export const RESEARCH_UI_URL = 'http://research.most.test';
export const PROCESS_LEASE_UI_URL = 'http://process-lease.most.test';
export const USER_PANEL_UI_URL = 'http://localhost:9226';
export const DOCS_UI_URL = 'http://docs.most.test';

export const ACCOMMODATION_UI_URL = 'http://accommodation.most.test';
export const ETICKET_UI_URL = 'http://eticket.most.test';
export const TEST_CONSULTANCY_UI_URL = 'http://testing.most.test';
export const HEALTH_UI_URL = 'http://health.most.test';
export const TRAINING_UI_URL = 'http://training.most.test';
export const VIRTUAL_GALLERY_UI_URL = 'http://vgallery.most.test';

export const CORE_SERVER_PREFIX = "qis";
export const CMS_SERVER_PREFIX = "cms";
export const GRANT_SERVER_PREFIX = "grant";
export const LICENSE_SERVER_PREFIX = "license";
export const ETICKET_SERVER_PREFIX = "eticket";
export const LIBRARY_SERVER_PREFIX = "library";
export const VIRTUAL_GALLERY_SERVER_PREFIX = "vgallery";
export const ACCOMMODATION_SERVER_PREFIX = "accommodation";
export const PROCESS_LEASE_SERVER_PREFIX = "process-lease";
export const RESEARCH_SERVER_PREFIX = "research";
export const TRAINING_SERVER_PREFIX = "training";
export const TEST_CONSULTANCY_SERVER_PREFIX = "testing";
export const HEALTH_SERVER_PREFIX = "health";
